<div *ngIf="!isLoading" style="margin-top: 3rem;">
    <h3 translate>COMMONS.PLANCOURSES</h3>
    <table mat-table [dataSource]="subCoursesTable" multiTemplateDataRows matSort class="table-style w-100">
      <ng-container matColumnDef="order">
        <td mat-cell *matCellDef="let index = dataIndex">
          {{ index + 1 }}
        </td>
      </ng-container>
      <ng-container matColumnDef="courseDescription">
        <td mat-cell *matCellDef="let element">
          {{ element.Description }}
        </td>
      </ng-container>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="element-row cp" (click)="openCourse(row)"></tr>
    </table>
</div>

<div *ngIf="isLoading">
    <tb-loading></tb-loading>
</div>
